import React from "react";
import {
  FolderOpenRounded,
  SchemaRounded,
  HubRounded,
  CableRounded,
  IntegrationInstructionsRounded,
  LanRounded,
} from "@mui/icons-material";
import { Box, Tabs, Tab, Divider, Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { GradientIconLight } from "../../../components/GradientIcon";
import { useThemeSettings } from "../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  gradientText: {
    background: theme.palette.light,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  customTabs: {
    minHeight: 36,
    marginTop: 2,
    "& .MuiTabs-indicator": {
      height: 4,
      borderRadius: "50px 50px 0px 0px",
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
    "& .MuiTab-root": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 6,
    },
    "& .MuiTabs-flexContainer": {
      minHeight: 36,
      paddingTop: 6,
      paddingBottom: 4,
    },
    "& .MuiTab-root.Mui-selected": {
      color:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "#9C27B0",
    },
  },
}));

export const tabs = [
  {
    label: "Processing Pipeline",
    value: "processing_pipeline",
    icon: CableRounded,
  },
  {
    label: "Integrations",
    value: "integrations",
    icon: LanRounded,
    isComingSoon: true,
  },
];

function DataManagementTabs({ currentTab, onTabChange }) {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const { classes } = useStyles();
  return (
    <Box>
      <Tabs
        centered
        value={currentTab}
        onChange={onTabChange}
        className={classes.customTabs}
        aria-label="data management tabs">
        {tabs.map((tab) => {
          const isSelected = tab.value === currentTab;
          return (
            <Tab
              key={tab.value}
              sx={{ minHeight: 52 }}
              label={
                <Box display={"flex"} alignItems={"center"}>
                  <span className={isSelected ? classes.gradientText : ""}>
                    {tab.label}
                  </span>
                  {tab.isComingSoon && (
                    <Chip
                      disabled
                      label="Coming Soon"
                      size="small"
                      sx={{ fontWeight: 500, borderRadius: 1, ml: 1 }}
                    />
                  )}
                </Box>
              }
              disabled={tab.isComingSoon}
              value={tab.value}
              icon={
                isSelected ? (
                  isDarkMode ? (
                    <tab.icon
                      sx={{
                        marginRight: 1,
                        color: (theme) => theme.palette.text.primary,
                      }}
                    />
                  ) : (
                    <GradientIconLight
                      Icon={tab.icon}
                      sx={{ marginRight: 1 }}
                    />
                  )
                ) : (
                  <tab.icon />
                )
              }
              iconPosition="start"
            />
          );
        })}
      </Tabs>
      <Divider />
    </Box>
  );
}

export default DataManagementTabs;
